export function getOrderLists (state: CRMState, lists: any): void {
    state.lists = lists;
}

export function onSetIsLoading (state: CRMState, isLoading: boolean): void {
    state.isLoading = isLoading;
}

export interface CRMState {
    lists: ListModel[],
    isLoading: boolean
}

export interface ListModel {
    id: number,
    name: string,
    list_number: number,
    country_to_id: number,
    country_from_id: number,
    responsible_partner_id: number,
    delivery_date: string,
    approx_delivery_date: string,
    available_weight: number,
    status: 1,
    date_added: string,
    from_countries_name: string,
    to_countries_name: string,
    firstname: string,
    lastname: string,
    total_weight: number
}

